import {
  Settings,
  User,
  Eye,
  EyeOff,
  Copy,
  UploadCloud,
  Image as ImageIcon,
} from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import { staffAPI } from "../../services/AdminPortal/staffAPI";
import { toast } from "react-hot-toast";
import {
  FaLinkedin,
  FaInstagram,
  FaFacebook,
  FaWhatsapp,
} from "react-icons/fa";
import { Globe } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const AddStaffForm = ({ onBack }) => {
  const navigate = useNavigate();
  const { sidebarExpanded, isMobile } = useSidebar();
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: "",
    // staffId: "",
    email: "",
    phone: "",
    location: "",
    dob: "",
    password: "",
    pincode: "",
    age: "",
    targetLoans: 0,
    profilePicture: null,
    socialMedia: {
      linkedin: "",
      instagram: "",
      facebook: "",
      whatsapp: "",
    },
    // confirmPassword: '',
    role: "",
    permissions: {
      system: {
        dashboard: true,
        manageSettings: true,
        auditLogs: true,
        apiIntegrations: true,
        isChecked: false,
      },
      lead: {
        rejectApproveLeads: true,
        requestDocuments: true,
        viewVerifyDocuments: true,
        viewLoanHistory: true,
      },
      loan: {
        createAssignApplications: true,
        approveRejectLoans: true,
        modifyConditions: true,
        viewAllHistory: true,
      },
      staff: {
        viewAll: true,
        addRemove: true,
        assignEditRoles: true,
        deactivateActivate: true,
      },
      finance: {
        processLoanDisbursements: true,
        managePartnerTransactions: true,
        generateReports: true,
        viewTotal: true,
      },
      affiliate: {
        addManagePartners: true,
        assignLoanFiles: true,
        viewAllPartners: true,
        manageCommission: true,
      },
    },
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for submission loading
  const [profilePicPreview, setProfilePicPreview] = useState(null); // For image preview
  const [rawProfilePic, setRawProfilePic] = useState(null); // To store the original selected file for the editor
  const [showEditorModal, setShowEditorModal] = useState(false);
  // const editorRef = React.useRef(null); // Ref for some editor libraries
  // const [editorScale, setEditorScale] = useState(1); // For zoom in editor

  const handletoggle = (e) => {
    const { id, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        system: {
          ...prev.permissions.system,
          [id]: checked,
        },
      },
    }));
  };

  const handleTogglePermission = (category, permission) => {
    setFormData((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [category]: {
          ...prev.permissions[category],
          [permission]: !prev.permissions[category][permission],
        },
      },
    }));
  };

  const handleRoleSelect = (role) => {
    const rolePermissions = {
      admin: {
        system: {
          dashboard: true,
          manageSettings: true,
          auditLogs: true,
          apiIntegrations: true,
        },
        lead: {
          rejectApproveLeads: true,
          requestDocuments: true,
          viewVerifyDocuments: true,
          viewLoanHistory: true,
        },
        loan: {
          createAssignApplications: true,
          approveRejectLoans: true,
          modifyConditions: true,
          viewAllHistory: true,
        },
        staff: {
          viewAll: true,
          addRemove: true,
          assignEditRoles: true,
          deactivateActivate: true,
        },
        finance: {
          processLoanDisbursements: true,
          managePartnerTransactions: true,
          generateReports: true,
          viewTotal: true,
        },
        affiliate: {
          addManagePartners: true,
          assignLoanFiles: true,
          viewAllPartners: true,
          manageCommission: true,
        },
      },
      "credit-manager": {
        system: {
          dashboard: false,
          manageSettings: false,
          auditLogs: false,
          apiIntegrations: false,
        },
        lead: {
          rejectApproveLeads: true,
          requestDocuments: true,
          viewVerifyDocuments: true,
          viewLoanHistory: true,
        },
        loan: {
          createAssignApplications: true,
          approveRejectLoans: true,
          modifyConditions: true,
          viewAllHistory: true,
        },
        staff: {
          viewAll: false,
          addRemove: false,
          assignEditRoles: false,
          deactivateActivate: false,
        },
        finance: {
          processLoanDisbursements: true,
          managePartnerTransactions: true,
          generateReports: true,
          viewTotal: true,
        },
        affiliate: {
          addManagePartners: false,
          assignLoanFiles: true,
          viewAllPartners: false,
          manageCommission: false,
        },
      },
      subAdmin: {
        system: {
          dashboard: true,
          manageSettings: true,
          auditLogs: true,
          apiIntegrations: true,
        },
        lead: {
          rejectApproveLeads: true,
          requestDocuments: true,
          viewVerifyDocuments: true,
          viewLoanHistory: true,
        },
        loan: {
          createAssignApplications: true,
          approveRejectLoans: true,
          modifyConditions: true,
          viewAllHistory: true,
        },
        staff: {
          viewAll: true,
          addRemove: true,
          assignEditRoles: true,
          deactivateActivate: true,
        },
        finance: {
          processLoanDisbursements: true,
          managePartnerTransactions: true,
          generateReports: true,
          viewTotal: true,
        },
        affiliate: {
          addManagePartners: true,
          assignLoanFiles: true,
          viewAllPartners: true,
          manageCommission: true,
        },
      },
      staff: {
        system: {
          dashboard: false,
          manageSettings: false,
          auditLogs: false,
          apiIntegrations: false,
        },
        lead: {
          rejectApproveLeads: true,
          requestDocuments: true,
          viewVerifyDocuments: true,
          viewLoanHistory: true,
        },
        loan: {
          createAssignApplications: true,
          approveRejectLoans: true,
          modifyConditions: true,
          viewAllHistory: true,
        },
        staff: {
          viewAll: false,
          addRemove: false,
          assignEditRoles: false,
          deactivateActivate: false,
        },
        finance: {
          processLoanDisbursements: false,
          managePartnerTransactions: false,
          generateReports: false,
          viewTotal: false,
        },
        affiliate: {
          addManagePartners: false,
          assignLoanFiles: false,
          viewAllPartners: false,
          manageCommission: false,
        },
      },
      hr: {
        system: {
          dashboard: false,
          manageSettings: false,
          auditLogs: false,
          apiIntegrations: false,
        },
        lead: {
          rejectApproveLeads: false,
          requestDocuments: false,
          viewVerifyDocuments: false,
          viewLoanHistory: false,
        },
        loan: {
          createAssignApplications: false,
          approveRejectLoans: false,
          modifyConditions: false,
          viewAllHistory: false,
        },
        staff: {
          viewAll: true,
          addRemove: true,
          assignEditRoles: true,
          deactivateActivate: true,
        },
        finance: {
          processLoanDisbursements: false,
          managePartnerTransactions: false,
          generateReports: false,
          viewTotal: false,
        },
        affiliate: {
          addManagePartners: false,
          assignLoanFiles: false,
          viewAllPartners: false,
          manageCommission: false,
        },
      },
      marketing: {
        system: {
          dashboard: false,
          manageSettings: false,
          auditLogs: false,
          apiIntegrations: false,
        },
        lead: {
          rejectApproveLeads: true,
          requestDocuments: true,
          viewVerifyDocuments: true,
          viewLoanHistory: true,
        },
        loan: {
          createAssignApplications: false,
          approveRejectLoans: false,
          modifyConditions: false,
          viewAllHistory: false,
        },
        staff: {
          viewAll: false,
          addRemove: false,
          assignEditRoles: false,
          deactivateActivate: false,
        },
        finance: {
          processLoanDisbursements: false,
          managePartnerTransactions: false,
          generateReports: false,
          viewTotal: false,
        },
        affiliate: {
          addManagePartners: true,
          assignLoanFiles: true,
          viewAllPartners: true,
          manageCommission: true,
        },
      },
      strategy: {
        system: {
          dashboard: false,
          manageSettings: false,
          auditLogs: false,
          apiIntegrations: false,
        },
        lead: {
          rejectApproveLeads: true,
          requestDocuments: true,
          viewVerifyDocuments: true,
          viewLoanHistory: true,
        },
        loan: {
          createAssignApplications: true,
          approveRejectLoans: true,
          modifyConditions: true,
          viewAllHistory: true,
        },
        staff: {
          viewAll: false,
          addRemove: false,
          assignEditRoles: false,
          deactivateActivate: false,
        },
        finance: {
          processLoanDisbursements: true,
          managePartnerTransactions: true,
          generateReports: true,
          viewTotal: true,
        },
        affiliate: {
          addManagePartners: true,
          assignLoanFiles: true,
          viewAllPartners: true,
          manageCommission: true,
        },
      },
      sales: {
        system: {
          dashboard: false,
          manageSettings: false,
          auditLogs: false,
          apiIntegrations: false,
        },
        lead: {
          rejectApproveLeads: true,
          requestDocuments: true,
          viewVerifyDocuments: true,
          viewLoanHistory: true,
        },
        loan: {
          createAssignApplications: true,
          approveRejectLoans: true,
          modifyConditions: true,
          viewAllHistory: true,
        },
        staff: {
          viewAll: false,
          addRemove: false,
          assignEditRoles: false,
          deactivateActivate: false,
        },
        finance: {
          processLoanDisbursements: true,
          managePartnerTransactions: true,
          generateReports: true,
          viewTotal: true,
        },
        affiliate: {
          addManagePartners: true,
          assignLoanFiles: true,
          viewAllPartners: true,
          manageCommission: true,
        },
      },
      technical: {
        system: {
          dashboard: true,
          manageSettings: true,
          auditLogs: true,
          apiIntegrations: true,
        },
        lead: {
          rejectApproveLeads: false,
          requestDocuments: false,
          viewVerifyDocuments: false,
          viewLoanHistory: false,
        },
        loan: {
          createAssignApplications: false,
          approveRejectLoans: false,
          modifyConditions: false,
          viewAllHistory: false,
        },
        staff: {
          viewAll: false,
          addRemove: false,
          assignEditRoles: false,
          deactivateActivate: false,
        },
        finance: {
          processLoanDisbursements: false,
          managePartnerTransactions: false,
          generateReports: false,
          viewTotal: false,
        },
        affiliate: {
          addManagePartners: false,
          assignLoanFiles: false,
          viewAllPartners: false,
          manageCommission: false,
        },
      },
      research: {
        system: {
          dashboard: true,
          manageSettings: false,
          auditLogs: false,
          apiIntegrations: false,
        },
        lead: {
          rejectApproveLeads: false,
          requestDocuments: false,
          viewVerifyDocuments: true,
          viewLoanHistory: true,
        },
        loan: {
          createAssignApplications: false,
          approveRejectLoans: false,
          modifyConditions: false,
          viewAllHistory: true,
        },
        staff: {
          viewAll: false,
          addRemove: false,
          assignEditRoles: false,
          deactivateActivate: false,
        },
        finance: {
          processLoanDisbursements: false,
          managePartnerTransactions: false,
          generateReports: true,
          viewTotal: true,
        },
        affiliate: {
          addManagePartners: false,
          assignLoanFiles: false,
          viewAllPartners: true,
          manageCommission: false,
        },
      },
    };
    setFormData((prev) => ({
      ...prev,
      role,
      permissions: rolePermissions[role] || {},
    }));
  };

  const handleResetToDefault = () => {
    const defaultRole = "admin"; // Default role
    const defaultPermissions = {
      system: {
        dashboard: true,
        manageSettings: true,
        auditLogs: true,
        apiIntegrations: true,
      },
      lead: {
        rejectApproveLeads: true,
        requestDocuments: true,
        viewVerifyDocuments: true,
        viewLoanHistory: true,
      },
      loan: {
        createAssignApplications: true,
        approveRejectLoans: true,
        modifyConditions: true,
        viewAllHistory: true,
      },
      staff: {
        viewAll: true,
        addRemove: true,
        assignEditRoles: true,
        deactivateActivate: true,
      },
      finance: {
        processLoanDisbursements: true,
        managePartnerTransactions: true,
        generateReports: true,
        viewTotal: true,
      },
      affiliate: {
        addManagePartners: true,
        assignLoanFiles: true,
        viewAllPartners: true,
        manageCommission: true,
      },
    };

    setFormData((prev) => ({
      ...prev,
      role: defaultRole,
      permissions: defaultPermissions,
    }));
  };
  const handleProfilePictureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg+xml",
      ];
      const maxFileSize = 5 * 1024 * 1024; // 5MB

      if (file.size > maxFileSize) {
        toast.error("File is too large. Maximum size is 5MB.");
        e.target.value = null;
        return;
      }

      if (allowedTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setProfilePicPreview(reader.result); // reader.result is the Base64 string for preview
          setFormData((prev) => ({ ...prev, profilePicture: reader.result })); // Store Base64 string
        };
        reader.readAsDataURL(file);
      } else {
        toast.error("Invalid file type. Please upload JPG, JPEG, PNG, or SVG.");
        e.target.value = null; // Reset file input
        setFormData((prev) => ({ ...prev, profilePicture: null }));
        setProfilePicPreview(null);
        setRawProfilePic(null);
      }
    } else {
      setFormData((prev) => ({ ...prev, profilePicture: null }));
      setProfilePicPreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Start loading
    try {
      if (
        !formData.name ||
        // !formData.staffId ||
        !formData.email ||
        !formData.phone ||
        !formData.location ||
        !formData.targetLoans ||
        !formData.age ||
        !formData.pincode ||
        !formData.password ||
        !formData.role
      ) {
        throw new Error("Please fill in all required fields.");
      }
      // Validate email format
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.email)) {
        throw new Error("Invalid email format.");
      }

      // Validate phone number format (example: 10 digits)
      const phonePattern = /^\d{10}$/;
      if (!phonePattern.test(formData.phone)) {
        throw new Error("Invalid phone number format. Please enter 10 digits.");
      }
      if (formData.password.length < 8) {
        throw new Error("Password must be at least 8 characters long.");
      }
      const dataToSubmit = { 
        ...formData,
        createdBy: user?._id || user?.id // Track who created this staff member
      };
      if (!dataToSubmit.profilePicture) {
        delete dataToSubmit.profilePicture;
      }
      const response = await staffAPI.createStaff(dataToSubmit);
      toast.success("Staff created successfully!");

      console.log("Staff created successfully:", response);

      const role = user?.role?.toLowerCase();
      if (["admin", "subadmin"].includes(role)) {
        navigate(`/${role}/staff`);
      } else {
        console.warn("Unknown role:", role);
      }
    } catch (error) {
      console.error("Error creating staff:", error);
      toast.error(error.message || "An error occurred while creating staff.");
    } finally {
      setIsSubmitting(false); // Stop loading
    }
  };

  const handleCancel = () => {
    const role = user?.role?.toLowerCase();
    if (["admin", "subadmin"].includes(role)) {
      navigate(`/${role}/staff`);
    } else {
      console.warn("Unknown role:", role);
    }
  };

  const generatePassword = () => {
    const length = 12;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setFormData({ ...formData, password });
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const copyToClipboard = () => {
    if (formData.password) {
      navigator.clipboard
        .writeText(formData.password)
        .then(() => toast.success("Password copied to clipboard!"))
        .catch((err) => console.error("Failed to copy password: ", err));
    }
  };

  return (
    <div
      className="min-h-screen bg-black text-white   mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />
      <div className="p-4 md:p-6">
        <div className="flex items-center mb-6">
          <a
            href="#"
            className="text-[#FFCA20] hover:underline"
            onClick={(e) => {
              e.preventDefault();
              const role = user?.role?.toLowerCase();
              if (["admin", "subadmin"].includes(role)) {
                navigate(`/${role}/staff`);
              } else {
                console.warn("Unknown role:", role);
              }
            }}
          >
            Staff Management
          </a>
          <span className="mx-2 text-gray-500">{">"}</span>
          <span>Add New Staff</span>
        </div>

        <form onSubmit={handleSubmit} className="w-full">
          {/* Personal Information */}
          <div className="bg-[#131313] rounded-lg p-4 md:p-6 w-full">
            <div className="bg-[#131313] rounded-lg p-4 md:p-6 w-full">
              <div className="flex flex-row gap-3">
                <User className="text-[#FFCA20] w-6 h-6" />
                <h2 className="text-lg font-medium mb-4">Basic Details</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-2">
                    Staff Name*
                    <input
                      type="text"
                      placeholder="Enter Staff Name"
                      className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          name: e.target.value,
                        }))
                      }
                    />
                  </label>
                </div>
                {/* <div>
                  <label className="block mb-2">
                    Staff ID*
                    <input
                      type="text"
                      placeholder="Enter Staff ID"
                      className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                      value={formData.staffId}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          staffId: e.target.value,
                        }))
                      }
                    />
                  </label>
                </div> */}
                
                <div>
                  <label className="block mb-2">
                    Email ID*
                    <input
                      type="email"
                      placeholder="Enter Staff Email ID"
                      className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          email: e.target.value,
                        }))
                      }
                    />
                  </label>
                </div>
                <div>
                  <label className="block mb-2">
                    Phone Number*
                    <input
                      type="tel"
                      placeholder="Enter Staff Phone Number"
                      className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                      value={formData.phone}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          phone: e.target.value,
                        }))
                      }
                    />
                  </label>
                  
                </div>
                <div>
                      <label className="block mb-2">
                        Location*
                        <input
                          type="text"
                          placeholder="City, State"
                          className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                          value={formData.location}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              location: e.target.value,
                            }))
                          }
                        />
                      </label>
                    </div>

                {/* Three fields in a row: Location, PIN Code, Age */}
                <div className="md:col-span-2">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* <div>
                      <label className="block mb-2">
                        Location*
                        <input
                          type="text"
                          placeholder="City, State"
                          className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                          value={formData.location}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              location: e.target.value,
                            }))
                          }
                        />
                      </label>
                    </div> */}
                    <div>
                      <label className="block mb-2">
                        PIN Code*
                        <input
                          type="text"
                          placeholder="Enter Pincode"
                          className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                          value={formData.pincode}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              pincode: e.target.value,
                            }))
                          }
                        />
                      </label>
                    </div>
                    <div>
                      <label className="block mb-2">
                        Age*
                        <input
                          type="number"
                          placeholder="Enter Age"
                          className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                          value={formData.age}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              age: e.target.value,
                            }))
                          }
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Branch Details */}
            <div className="bg-[#131313] rounded-lg p-4 md:p-6  w-full">
              <div className="flex flex-row gap-3">
                <User className="text-[#FFCA20] w-6 h-6" />
                <h2 className="text-lg font-medium mb-4">Branch Details</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block mb-2">
                    Branch Name*
                    <input
                      type="text"
                      placeholder="Enter Branch Name"
                      className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                      value={formData.branchName}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          branchName: e.target.value,
                        }))
                      }
                    />
                  </label>
                </div>
                <div>
                  <label className="block mb-2">
                    Branch Type*
                    <select
                      className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                      value={formData.branchType}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          branchType: e.target.value,
                        }))
                      }
                    >
                      <option value="">Select Branch Type</option>
                      <option value="district">District level</option>
                      <option value="mandal">Mandal level</option>
                      <option value="village">Village level</option>
                    </select>
                  </label>
                </div>
                <div>
                  <label className="block mb-2">
                    Branch Location*
                    <input
                      type="text"
                      placeholder="Enter Branch Location"
                      className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                      value={formData.branchLocation}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          branchLocation: e.target.value,
                        }))
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
            {/* Branch Details */}
            <div className="bg-[#131313] rounded-lg p-4 md:p-6 w-full">
              <div className="flex flex-row gap-3">
                <User className="text-[#FFCA20] w-6 h-6" />
                <h2 className="text-lg font-medium mb-4">
                  Add Montly Target Loans
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block mb-2">
                    Montly Target Loans
                    <input
                      type="number"
                      placeholder="Enter Montly Target Loans"
                      className="w-full bg-[#131313] border border-[#333333] rounded p-2 mt-1"
                      value={formData.targetLoans}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          targetLoans: e.target.value,
                        }))
                      }
                    />
                  </label>
                </div>
              </div>
            </div>

            {/* Login Credentials and Profile Picture Section */}
            <div className="flex flex-col gap-2 text-left mt-6">
              {" "}
              {/* Added mt-6 for spacing */}
              <div className="flex flex-row items-center gap-3">
                <User className="text-yellow-500 w-6 h-6" />
                <h2 className="text-lg font-medium mb-1">
                  Login Credentials & Profile Photo
                </h2>
              </div>
              <div className="flex flex-col md:flex-row gap-6 items-start">
                {" "}
                {/* Flex container for side-by-side */}
                {/* Password Section */}
                <div className="w-full md:w-1/2">
                  <label className="block mb-1">Password*</label>
                  <div className="flex items-center gap-2">
                    <div className="relative w-[60%]">
                      <input
                        type="text"
                        placeholder="Enter Staff Password"
                        className="w-full bg-[#131313] border border-[#333333] rounded-lg p-2 pr-8"
                        value={formData.password}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            password: e.target.value,
                          }))
                        }
                      />
                      <button
                        type="button"
                        onClick={copyToClipboard}
                        disabled={!formData.password}
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-200"
                      >
                        <Copy size={16} />
                      </button>
                    </div>
                    <button
                      type="button"
                      className="bg-yellow-500 text-sm font-semibold text-[#1e1e1e] w-1/3 hover:bg-yellow-300 transition-colors duration-300 px-4 py-2 rounded-md"
                      onClick={generatePassword}
                    >
                      Generate
                    </button>
                  </div>
                </div>
                {/* Profile Picture Upload Section */}
                <div className="w-full md:w-1/2">
                  <label className="block mb-1">Profile Picture</label>
                  <div className="flex items-center gap-4">
                    <label
                      htmlFor="profilePictureInput"
                      className="w-20 h-20 rounded-full bg-[#131313] border border-[#333333] flex items-center justify-center overflow-hidden cursor-pointer"
                    >
                      {profilePicPreview ? (
                        <img
                          src={profilePicPreview}
                          alt="Profile Preview"
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <ImageIcon size={30} className="text-gray-500" />
                      )}
                    </label>
                    <div>
                      <input
                        id="profilePictureInput"
                        type="file"
                        accept=".jpg,.jpeg,.png,.svg"
                        className="hidden"
                        onChange={handleProfilePictureChange}
                      />
                      <p className="text-white text-base font-semibold mt-1">
                        Select Image for Profile Picture
                      </p>
                      <p className="text-xs text-gray-400 mt-1">
                        JPG, JPEG, PNG, SVG. Max 5MB.
                      </p>
                      {formData.profilePicture && (
                        <p className="text-xs text-green-500 mt-1">
                          {formData.profilePicture.name}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Social Media Links */}
          <div className="bg-[#131313] rounded-lg p-4 md:p-6 mb-6 w-full">
            <div className="flex flex-row gap-3 items-center mb-4">
              <Globe className="text-[#FFCA20] w-6 h-6" />
              <h2 className="text-lg font-medium">Social Media</h2>
            </div>
            <div className="space-y-4">
              {/* LinkedIn */}
              <div className="flex items-center gap-3">
                <FaLinkedin className="text-[#0A66C2] w-5 h-5" /> Linkedin
                <input
                  type="text"
                  name="linkedin"
                  placeholder="https://www.linkedin.com/in/your-profile"
                  className="w-full bg-[#131313] border border-[#333333] rounded p-2"
                  value={formData.socialMedia.linkedin}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      socialMedia: {
                        ...prev.socialMedia,
                        linkedin: e.target.value,
                      },
                    }))
                  }
                />
              </div>

              {/* Instagram */}
              <div className="flex items-center gap-3">
                <FaInstagram className="text-[#E1306C] w-5 h-5" /> Instagram
                <input
                  type="text"
                  name="instagram"
                  placeholder="https://www.instagram.com/your-profile"
                  className="w-full bg-[#131313] border border-[#333333] rounded p-2"
                  value={formData.socialMedia.instagram}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      socialMedia: {
                        ...prev.socialMedia,
                        instagram: e.target.value,
                      },
                    }))
                  }
                />
              </div>

              {/* Facebook */}
              <div className="flex items-center gap-3">
                <FaFacebook className="text-[#1877F2] w-5 h-5" /> Facebook
                <input
                  type="text"
                  name="facebook"
                  placeholder="https://www.facebook.com/your-profile"
                  className="w-full bg-[#131313] border border-[#333333] rounded p-2"
                  value={formData.socialMedia.facebook}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      socialMedia: {
                        ...prev.socialMedia,
                        facebook: e.target.value,
                      },
                    }))
                  }
                />
              </div>

              {/* WhatsApp */}
              <div className="flex items-center gap-3">
                <FaWhatsapp className="text-[#25D366] w-5 h-5" /> WhatsApp
                <input
                  type="text"
                  name="whatsapp"
                  placeholder="Enter Your Whatsapp Number"
                  className="w-full bg-[#131313] border border-[#333333] rounded p-2"
                  value={formData.socialMedia.whatsapp}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      socialMedia: {
                        ...prev.socialMedia,
                        whatsapp: e.target.value,
                      },
                    }))
                  }
                />
              </div>
            </div>
          </div>

          {/* Role & Permissions */}
          <div className="bg-[#131313] rounded-lg p-4 md:p-6 mb-6 w-full">
            <h2 className="text-lg font-medium mb-4">Role & Permissions</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div
                onClick={() => handleRoleSelect("admin")}
                className={`p-4 border ${
                  formData.role === "admin"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="45"
                      height="45"
                      rx="4"
                      fill={
                        formData.role === "admin"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />{" "}
                    {/* Conditional fill, added stroke */}
                    <path
                      d="M32.3438 14.4375C33.1875 14.8125 33.75 15.6094 33.75 16.5C33.75 28.6875 24.7969 34.5 22.4531 34.5C20.1094 34.5 11.25 28.5938 11.25 16.5C11.25 15.6094 11.7656 14.8125 12.6094 14.4375L21.6094 10.6875C21.8906 10.5938 22.1719 10.5 22.5 10.5C22.7812 10.5 23.0625 10.5938 23.3438 10.6875L32.3438 14.4375ZM22.5 32.25C25.5938 30.9844 31.5 26.0156 31.5 16.5L22.5 12.7969V32.25Z"
                      fill={formData.role === "admin" ? "#423715" : "#ffca20"}
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">Admin</h3>
                    <p className="text-xs text-gray-400">Full System Access</p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("subAdmin")}
                className={`p-4 border ${
                  formData.role === "subAdmin"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="46"
                    height="45"
                    viewBox="0 0 46 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H41.5C43.7091 0 45.5 1.79086 45.5 4V41C45.5 43.2091 43.7091 45 41.5 45H4.5C2.29086 45 0.5 43.2091 0.5 41V4Z"
                      fill={
                        formData.role === "subAdmin"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />{" "}
                    {/* Conditional fill, added stroke */}
                    <path
                      d="M26.375 10.5C31.1094 10.5 35 14.3906 35 19.125C35 24.3281 30.2656 28.5469 24.9219 27.6094L23.9844 28.5469C23.6094 28.875 23.1875 29.0625 22.7188 29.0625H21.4062V30C21.4062 30.9844 20.5625 31.7812 19.5781 31.7812H18.6875V32.7188C18.6875 33.7031 17.8438 34.5 16.8594 34.5H12.7812C11.7969 34.5 11 33.7031 11 32.7188V28.5C11 27.8438 11.2344 27.2344 11.7031 26.7656L17.8906 20.5781C17.7969 20.0625 17.7969 19.5938 17.7969 19.125C17.7969 14.3906 21.6406 10.5 26.375 10.5ZM24.8281 25.2656C29.0469 26.3438 32.75 23.1094 32.75 19.125C32.75 15.6094 29.8906 12.75 26.375 12.75C22.8594 12.75 20.0469 15.6094 20.0469 19.125C20.0469 19.6406 20.0938 20.1562 20.2344 20.6719L20.375 21.2812L13.2969 28.3594C13.25 28.4062 13.25 28.4531 13.25 28.5V32.25H16.4375V29.5312H19.1562V26.8125H22.5312L24.2188 25.125L24.8281 25.2656ZM28.25 15.75C29.0469 15.75 29.75 16.4531 29.75 17.25C29.75 18.0938 29.0469 18.75 28.25 18.75C27.4062 18.75 26.75 18.0938 26.75 17.25C26.75 16.4531 27.4062 15.75 28.25 15.75Z"
                      fill={
                        formData.role === "subAdmin" ? "#423715" : "#ffca20"
                      }
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">Sub-Admin</h3>
                    <p className="text-xs text-gray-400">
                      Limited Admin Access
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("credit-manager")}
                className={`p-4 border ${
                  formData.role === "credit-manager"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 4C0 1.79086 1.79086 0 4 0H41C43.2091 0 45 1.79086 45 4V41C45 43.2091 43.2091 45 41 45H4C1.79086 45 0 43.2091 0 41V4Z"
                      fill={
                        formData.role === "credit-manager"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />{" "}
                    {/* Conditional fill, added stroke */}
                    <path
                      d="M17.25 18.75C18.0469 18.75 18.75 19.4531 18.75 20.25C18.75 21.0938 18.0469 21.75 17.25 21.75C16.4062 21.75 15.75 21.0938 15.75 20.25C15.75 19.4531 16.4062 18.75 17.25 18.75ZM15 24C15.7969 24 16.5 24.7031 16.5 25.5C16.5 26.3438 15.7969 27 15 27C14.1562 27 13.5 26.3438 13.5 25.5C13.5 24.7031 14.1562 24 15 24ZM28.5 25.5C28.5 24.7031 29.1562 24 30 24C30.7969 24 31.5 24.7031 31.5 25.5C31.5 26.3438 30.7969 27 30 27C29.1562 27 28.5 26.3438 28.5 25.5ZM22.5 12C29.9531 12 36 18.0469 36 25.5C36 27.9844 35.2969 30.3281 34.1719 32.2969C33.8906 32.7656 33.375 33 32.8594 33H12.0938C11.5781 33 11.0625 32.7656 10.8281 32.2969C9.65625 30.3281 9 27.9844 9 25.5C9 18.0469 15.0469 12 22.5 12ZM22.5 30.75C23.5312 30.75 24.375 29.9531 24.375 28.875C24.375 27.8438 23.5312 27 22.5 27C21.4219 27 20.625 27.8438 20.625 28.875C20.625 29.9531 21.4219 30.75 22.5 30.75ZM32.4375 30.75C33.2812 29.1562 33.75 27.375 33.75 25.5C33.75 19.3125 28.6875 14.25 22.5 14.25C16.2656 14.25 11.25 19.3125 11.25 25.5C11.25 27.375 11.6719 29.1562 12.5156 30.75H18.8438C18.5156 30.1875 18.375 29.5781 18.375 28.875C18.375 26.625 20.2031 24.75 22.5 24.75C22.8281 24.75 23.1562 24.8438 23.4844 24.8906L27.1406 19.2656C27.5156 18.75 28.1719 18.6094 28.7344 18.9375C29.25 19.3125 29.3906 20.0156 29.0625 20.5312L25.4531 26.0156C26.1562 26.7656 26.625 27.7969 26.625 28.875C26.625 29.5781 26.4375 30.1875 26.1094 30.75H32.4375ZM22.5 16.5C23.2969 16.5 24 17.2031 24 18C24 18.8438 23.2969 19.5 22.5 19.5C21.6562 19.5 21 18.8438 21 18C21 17.2031 21.6562 16.5 22.5 16.5Z"
                      fill={
                        formData.role === "credit-manager"
                          ? "#423715"
                          : "#ffca20"
                      }
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">Credit Manager</h3>
                    <p className="text-xs text-gray-400">
                      Financial Operations Access
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("staff")}
                className={`p-4 border ${
                  formData.role === "staff"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="46"
                    height="45"
                    viewBox="0 0 46 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H41.5C43.7091 0 45.5 1.79086 45.5 4V41C45.5 43.2091 43.7091 45 41.5 45H4.5C2.29086 45 0.5 43.2091 0.5 41V4Z"
                      fill={
                        formData.role === "staff"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />{" "}
                    {/* Conditional fill, added stroke */}
                    <path
                      d="M31.1094 14.9062C31.6719 15.4688 32 16.2188 32 17.0156V31.5C32 33.1875 30.6406 34.5 29 34.5H17C15.3125 34.5 14 33.1875 14 31.5V13.5C14 11.8594 15.3125 10.5 17 10.5H25.4844C26.2812 10.5 27.0312 10.8281 27.5938 11.3906L31.1094 14.9062ZM29.75 31.5V18H26C25.1562 18 24.5 17.3438 24.5 16.5V12.7969H17C16.5781 12.7969 16.25 13.125 16.25 13.5469V31.5C16.25 31.9219 16.5781 32.25 17 32.25H29C29.375 32.25 29.75 31.9219 29.75 31.5ZM18.5 23.625C18.5 23.0156 18.9688 22.5 19.625 22.5H26.375C26.9844 22.5 27.5 23.0156 27.5 23.625C27.5 24.2812 26.9844 24.75 26.375 24.75H19.625C18.9688 24.75 18.5 24.2812 18.5 23.625ZM26.375 27C26.9844 27 27.5 27.5156 27.5 28.125C27.5 28.7812 26.9844 29.25 26.375 29.25H19.625C18.9688 29.25 18.5 28.7812 18.5 28.125C18.5 27.5156 18.9688 27 19.625 27H26.375Z"
                      fill={formData.role === "staff" ? "#423715" : "#ffca20"}
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">Loan Officer</h3>
                    <p className="text-xs text-gray-400">
                      Loan Management Access
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("hr")}
                className={`p-4 border ${
                  formData.role === "hr"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 4C0 1.79086 1.79086 0 4 0H41C43.2091 0 45 1.79086 45 4V41C45 43.2091 43.2091 45 41 45H4C1.79086 45 0 43.2091 0 41V4Z"
                      fill={
                        formData.role === "hr"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />{" "}
                    {/* Conditional fill, added stroke */}
                    <path
                      d="M18 22.5C14.6719 22.5 12 19.8281 12 16.5C12 13.2188 14.6719 10.5 18 10.5C21.2812 10.5 24 13.2188 24 16.5C24 19.8281 21.2812 22.5 18 22.5ZM18 12.75C15.8906 12.75 14.25 14.4375 14.25 16.5C14.25 18.6094 15.8906 20.25 18 20.25C20.0625 20.25 21.75 18.6094 21.75 16.5C21.75 14.4375 20.0625 12.75 18 12.75ZM20.3438 24.75C24.8438 24.75 28.5 28.4062 28.5 32.9062C28.5 33.7969 27.75 34.5 26.8594 34.5H9.09375C8.20312 34.5 7.5 33.7969 7.5 32.9062C7.5 28.4062 11.1094 24.75 15.6094 24.75H20.3438ZM9.75 32.25H26.2031C25.875 29.3438 23.3906 27 20.3438 27H15.6094C12.5625 27 10.0781 29.3438 9.75 32.25ZM29.9531 25.5C34.125 25.5 37.5 28.875 37.5 33C37.5 33.8438 36.7969 34.5 36 34.5H29.5312C29.8125 34.0312 30 33.5156 30 32.9062C30 29.9531 28.6406 27.2812 26.5312 25.5H29.9531ZM27.75 22.5C26.25 22.5 24.9375 21.9375 24 20.9531C24.9375 19.7344 25.5 18.1875 25.5 16.5C25.5 15.2812 25.125 14.1094 24.6094 13.0781C25.4531 12.4219 26.5312 12 27.75 12C30.6094 12 33 14.3906 33 17.25C33 20.1562 30.6094 22.5 27.75 22.5Z"
                      fill={formData.role === "hr" ? "#423715" : "#ffca20"}
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">
                      Human Resources Management
                    </h3>
                    <p className="text-xs text-gray-400">
                      Staff recruitment, performance tracking, and internal team
                      coordination.
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("marketing")}
                className={`p-4 border ${
                  formData.role === "marketing"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="46"
                    height="45"
                    viewBox="0 0 46 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H41.5C43.7091 0 45.5 1.79086 45.5 4V41C45.5 43.2091 43.7091 45 41.5 45H4.5C2.29086 45 0.5 43.2091 0.5 41V4Z"
                      fill={
                        formData.role === "marketing"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />{" "}
                    {/* Conditional fill, added stroke */}
                    <path
                      d="M15.5 25.5C12.9688 25.5 11 23.5312 11 21C11 18.5156 12.9688 16.5 15.5 16.5C17.9844 16.5 20 18.5156 20 21C20 23.5312 17.9844 25.5 15.5 25.5ZM15.5 18.75C14.2344 18.75 13.25 19.7812 13.25 21C13.25 22.2656 14.2344 23.25 15.5 23.25C16.7188 23.25 17.75 22.2656 17.75 21C17.75 19.7812 16.7188 18.75 15.5 18.75ZM17 27C20.2812 27 23 29.7188 23 33C23 33.8438 22.2969 34.5 21.5 34.5H9.5C8.65625 34.5 8 33.8438 8 33C8 29.7188 10.6719 27 14 27H17ZM10.2969 32.25H20.6562C20.2812 30.5625 18.7812 29.25 17 29.25H14C12.1719 29.25 10.6719 30.5625 10.2969 32.25ZM35.375 10.5C36.7812 10.5 38 11.7188 38 13.125V27.375C38 28.8281 36.7812 30 35.375 30H24.5C23.8438 30 23.375 29.5312 23.375 28.875C23.375 28.2656 23.8438 27.75 24.5 27.75H35.375C35.5625 27.75 35.75 27.6094 35.75 27.375V13.125C35.75 12.9375 35.5625 12.75 35.375 12.75H18.125C17.8906 12.75 17.75 12.9375 17.75 13.125V14.25C17.75 14.9062 17.2344 15.375 16.625 15.375C15.9688 15.375 15.5 14.9062 15.5 14.25V13.125C15.5 11.7188 16.6719 10.5 18.125 10.5H35.375ZM23.375 18.375L26 20.9531L29.6562 17.25H28.625C27.9688 17.25 27.5 16.7812 27.5 16.125C27.5 15.5156 27.9688 15 28.625 15H32.375C32.9844 15 33.5 15.5156 33.5 16.125V19.875C33.5 20.5312 32.9844 21 32.375 21C31.7188 21 31.25 20.5312 31.25 19.875V18.8438L26.75 23.2969C26.5625 23.5312 26.2812 23.625 26 23.625C25.6719 23.625 25.3906 23.5312 25.2031 23.2969L21.8281 19.9219C21.3594 19.5 21.3594 18.7969 21.8281 18.375C22.25 17.9062 22.9531 17.9062 23.375 18.375Z"
                      fill={
                        formData.role === "marketing" ? "#423715" : "#ffca20"
                      }
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">
                      Marketing Officer (Digital and Offline)
                    </h3>
                    <p className="text-xs text-gray-400">
                      Plan and execute marketing campaigns
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("strategy")}
                className={`p-4 border ${
                  formData.role === "strategy"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 4C0 1.79086 1.79086 0 4 0H41C43.2091 0 45 1.79086 45 4V41C45 43.2091 43.2091 45 41 45H4C1.79086 45 0 43.2091 0 41V4Z"
                      fill={
                        formData.role === "strategy"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />{" "}
                    {/* Conditional fill, added stroke */}
                    <path
                      d="M18.75 19.5C19.3594 19.5 19.875 20.0156 19.875 20.625V33.1406C19.875 33.75 19.3594 34.2656 18.75 34.2656C18.0938 34.2656 17.625 33.75 17.625 33.1406V20.625C17.625 20.0156 18.0938 19.5 18.75 19.5ZM11.25 27C11.8594 27 12.375 27.5156 12.375 28.125V33.375C12.375 34.0312 11.8594 34.5 11.25 34.5C10.5938 34.5 10.125 34.0312 10.125 33.375V28.125C10.125 27.5156 10.5938 27 11.25 27ZM33.75 10.5C34.9688 10.5 36 11.5312 36 12.75C36 14.0156 34.9688 15 33.75 15C33.4219 15 33.1875 14.9531 32.9062 14.8594L28.4531 18.4219C28.4531 18.5625 28.5 18.6562 28.5 18.75C28.5 20.0156 27.4688 21 26.25 21C24.9844 21 24 20.0156 24 18.75C24 18.6562 24 18.5625 24 18.4219L19.5469 14.8594C19.3125 14.9531 19.0312 15 18.75 15C18.5156 15 18.3281 15 18.1406 14.9531L13.4062 19.6875C13.4531 19.875 13.5 20.0625 13.5 20.25C13.5 21.5156 12.4688 22.5 11.25 22.5C9.98438 22.5 9 21.5156 9 20.25C9 19.0312 9.98438 18 11.25 18C11.4375 18 11.625 18.0469 11.8125 18.0938L16.5469 13.3594C16.5 13.1719 16.5 12.9844 16.5 12.75C16.5 11.5312 17.4844 10.5 18.75 10.5C19.9688 10.5 21 11.5312 21 12.75C21 12.8906 20.9531 12.9844 20.9531 13.125L25.4062 16.6875C25.6875 16.5938 25.9219 16.5 26.25 16.5C26.5312 16.5 26.8125 16.5938 27.0469 16.6875L31.5 13.125C31.5 12.9844 31.5 12.8906 31.5 12.75C31.5 11.5312 32.4844 10.5 33.75 10.5ZM26.25 25.5C26.8594 25.5 27.375 26.0156 27.375 26.625V33.1875C27.375 33.7969 26.8594 34.3125 26.25 34.3125C25.5938 34.3125 25.125 33.7969 25.125 33.1875V26.625C25.125 26.0156 25.5938 25.5 26.25 25.5ZM33.75 19.5C34.3594 19.5 34.875 20.0156 34.875 20.625V33.375C34.875 34.0312 34.3594 34.5 33.75 34.5C33.0938 34.5 32.625 34.0312 32.625 33.375V20.625C32.625 20.0156 33.0938 19.5 33.75 19.5Z"
                      fill={
                        formData.role === "strategy" ? "#423715" : "#ffca20"
                      }
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">Strategy Developers Team</h3>
                    <p className="text-xs text-gray-400">
                      Research, analyze, and implement business growth
                      strategies
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("sales")}
                className={`p-4 border ${
                  formData.role === "sales"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 4C0 1.79086 1.79086 0 4 0H41C43.2091 0 45 1.79086 45 4V41C45 43.2091 43.2091 45 41 45H4C1.79086 45 0 43.2091 0 41V4Z"
                      fill={
                        formData.role === "sales"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />{" "}
                    {/* Conditional fill, added stroke */}
                    <path
                      d="M15 25.5C12.4688 25.5 10.5 23.5312 10.5 21C10.5 18.5156 12.4688 16.5 15 16.5C17.4844 16.5 19.5 18.5156 19.5 21C19.5 23.5312 17.4844 25.5 15 25.5ZM15 18.75C13.7344 18.75 12.75 19.7812 12.75 21C12.75 22.2656 13.7344 23.25 15 23.25C16.2188 23.25 17.25 22.2656 17.25 21C17.25 19.7812 16.2188 18.75 15 18.75ZM16.5 27C19.7812 27 22.5 29.7188 22.5 33C22.5 33.8438 21.7969 34.5 21 34.5H9C8.15625 34.5 7.5 33.8438 7.5 33C7.5 29.7188 10.1719 27 13.5 27H16.5ZM9.79688 32.25H20.1562C19.7812 30.5625 18.2812 29.25 16.5 29.25H13.5C11.6719 29.25 10.1719 30.5625 9.79688 32.25ZM34.875 10.5C36.2812 10.5 37.5 11.7188 37.5 13.125V27.375C37.5 28.8281 36.2812 30 34.875 30H24C23.3438 30 22.875 29.5312 22.875 28.875C22.875 28.2656 23.3438 27.75 24 27.75H34.875C35.0625 27.75 35.25 27.6094 35.25 27.375V13.125C35.25 12.9375 35.0625 12.75 34.875 12.75H17.625C17.3906 12.75 17.25 12.9375 17.25 13.125V14.25C17.25 14.9062 16.7344 15.375 16.125 15.375C15.4688 15.375 15 14.9062 15 14.25V13.125C15 11.7188 16.1719 10.5 17.625 10.5H34.875ZM22.875 18.375L25.5 20.9531L29.1562 17.25H28.125C27.4688 17.25 27 16.7812 27 16.125C27 15.5156 27.4688 15 28.125 15H31.875C32.4844 15 33.5 15.5156 33 16.125V19.875C33 20.5312 32.4844 21 31.875 21C31.2188 21 30.75 20.5312 30.75 19.875V18.8438L26.25 23.2969C26.0625 23.5312 25.7812 23.625 25.5 23.625C25.1719 23.625 24.8906 23.5312 24.7031 23.2969L21.3281 19.9219C20.8594 19.5 20.8594 18.7969 21.3281 18.375C21.75 17.9062 22.4531 17.9062 22.875 18.375Z"
                      fill={formData.role === "sales" ? "#423715" : "#ffca20"}
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">Sales Team</h3>
                    <p className="text-xs text-gray-400">
                      Plan and execute marketing campaigns
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("technical")}
                className={`p-4 border ${
                  formData.role === "technical"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 4C0 1.79086 1.79086 0 4 0H41C43.2091 0 45 1.79086 45 4V41C45 43.2091 43.2091 45 41 45H4C1.79086 45 0 43.2091 0 41V4Z"
                      fill={
                        formData.role === "technical"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />
                    <path
                      d="M36.375 27C36.9844 27 37.5 27.5156 37.5 28.125V28.875C37.5 31.1719 35.625 33 33.375 33H11.625C9.32812 33 7.5 31.1719 7.5 28.875V28.125C7.5 27.5156 7.96875 27 8.625 27H36.375ZM33.375 30.75C34.2656 30.75 35.0156 30.1406 35.2031 29.25H9.75C9.9375 30.1406 10.6875 30.75 11.625 30.75H33.375ZM12.75 14.625V25.5H10.5V14.625C10.5 13.2188 11.6719 12 13.125 12H31.875C33.2812 12 34.5 13.2188 34.5 14.625V25.5H32.25V14.625C32.25 14.4375 32.0625 14.25 31.875 14.25H13.125C12.8906 14.25 12.75 14.4375 12.75 14.625Z"
                      fill={
                        formData.role === "technical" ? "#423715" : "#ffca20"
                      }
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">Technical Team</h3>
                    <p className="text-xs text-gray-400">
                      Develop and maintain system infrastructure, databases, and
                      software tools
                    </p>
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleRoleSelect("research")}
                className={`p-4 border ${
                  formData.role === "research"
                    ? "border-yellow-500 bg-[#FFCA20]/10"
                    : "border-[#333333] hover:border-yellow-500/50" // Added hover effect
                } rounded cursor-pointer`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 4C0 1.79086 1.79086 0 4 0H41C43.2091 0 45 1.79086 45 4V41C45 43.2091 43.2091 45 41 45H4C1.79086 45 0 43.2091 0 41V4Z"
                      fill={
                        formData.role === "research"
                          ? "#FFCA20"
                          : "rgba(255, 202, 32, 0.3)"
                      }
                    />
                    <path
                      d="M34.125 22.5C34.125 29.1094 28.5938 34.4531 21.9375 34.125C16.0312 33.8438 11.1562 28.9688 10.875 23.0625C10.5469 16.4062 15.8906 10.875 22.5 10.875C24.7969 10.875 27.0938 11.5781 29.0156 12.8906L30.1406 11.7656C30.6094 11.2969 31.3125 11.2969 31.7344 11.7656C32.2031 12.1875 32.2031 12.8906 31.7344 13.3594L22.5469 22.5H25.5C25.5 24.1875 24.1406 25.5 22.5 25.5469C20.8594 25.5469 19.5 24.2344 19.5 22.5938C19.4531 20.9531 20.7188 19.5938 22.3594 19.5469L24 17.9062C23.4844 17.7188 23.0156 17.6719 22.5 17.625C19.7812 17.625 17.5781 19.875 17.625 22.5938C17.625 25.1719 19.8281 27.375 22.4062 27.375C25.125 27.4219 27.375 25.2188 27.375 22.5H29.625C29.625 25.9688 27.1406 28.875 23.8594 29.4844C23.4844 29.1094 23.0156 28.875 22.5 28.875C21.9375 28.875 21.4688 29.1094 21.0938 29.4844C18.2812 28.9688 16.0312 26.7188 15.5156 23.9062C15.8906 23.5312 16.125 23.0625 16.125 22.5C16.125 21.9844 15.8906 21.5156 15.5156 21.1406C16.125 17.8594 18.9844 15.375 22.5 15.375C23.625 15.375 24.75 15.7031 25.6875 16.2188L27.375 14.5312C25.9219 13.6406 24.1875 13.125 22.5 13.125C17.8594 13.125 13.9688 16.5469 13.2656 20.9531C12.7031 21.2812 12.375 21.8438 12.375 22.5C12.375 23.2031 12.7031 23.7656 13.2656 24.0938C13.9219 27.9844 17.0156 31.0781 20.9062 31.7344C21.2344 32.2969 21.7969 32.625 22.5 32.625C23.1562 32.625 23.7188 32.2969 24.0469 31.7344C28.4531 31.0312 31.875 27.1406 31.875 22.5H34.125Z"
                      fill={
                        formData.role === "research" ? "#423715" : "#ffca20"
                      }
                    />
                  </svg>

                  <div>
                    <h3 className="font-semibold">R&D Team</h3>
                    <p className="text-xs text-gray-400">
                      Explore emerging technologies and concept models for user
                      engagement
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Permissions Configuration Section */}
          <div className="bg-[#131313] rounded-lg p-4 md:p-6 mb-6 w-full">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <Settings size={20} className="text-[#FFCA20]" />
                <h2 className="text-lg font-bold">Permissions Configuration</h2>
              </div>
              <button
                type="button"
                onClick={handleResetToDefault}
                className="text-gray-100"
              >
                Reset to Default
              </button>
            </div>

            <div className="space-y-6">
              {/* System Permissions Section */}
              <div>
                <div className="mb-2">
                  <input
                    type="checkbox"
                    id="system_permissions"
                    className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:border-yellow-400 checked:appearance-none relative cursor-pointer
             before:content-['✔'] before:absolute before:text-[#ffca20] before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100 mr-2"
                    checked={Object.values(formData.permissions.system).some(
                      (val) => val
                    )}
                    onChange={() => {
                      handletoggle();
                    }}
                  />
                  <label htmlFor="system_permissions" className="font-semibold">
                    System Permissions
                  </label>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="dashboard">Dashboard Access</label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="dashboard"
                        className="sr-only"
                        checked={formData.permissions.system.dashboard}
                        onChange={() =>
                          handleTogglePermission("system", "dashboard")
                        }
                      />
                      <div
                        className={`w-full h-full rounded-full border-2 transition-colors duration-300 ${
                          formData.permissions.system.dashboard
                            ? "bg-[#3E3212] border-[#FFCA20]"
                            : "bg-[#3E3212] border-[#FFCA20]"
                        }`}
                      ></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.system.dashboard
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="manageSettings">
                      Manage System Settings
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="manageSettings"
                        className="sr-only"
                        checked={formData.permissions.system.manageSettings}
                        onChange={() =>
                          handleTogglePermission("system", "manageSettings")
                        }
                      />
                      <div
                        className={`w-full h-full rounded-full border-2 transition-colors duration-300 ${
                          formData.permissions.system.manageSettings
                            ? "bg-[#3E3212] border-[#FFCA20]"
                            : "bg-[#3E3212] border-[#FFCA20]"
                        }`}
                      ></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.system.manageSettings
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="auditLogs">Access Audit Logs</label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="auditLogs"
                        className="sr-only"
                        checked={formData.permissions.system.auditLogs}
                        onChange={() =>
                          handleTogglePermission("system", "auditLogs")
                        }
                      />
                      <div
                        className={`w-full h-full rounded-full border-2 transition-colors duration-300 ${
                          formData.permissions.system.auditLogs
                            ? "bg-[#3E3212] border-[#FFCA20]"
                            : "bg-[#3E3212] border-[#FFCA20]"
                        }`}
                      ></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.system.auditLogs
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="apiIntegrations">API & Integrations</label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="apiIntegrations"
                        className="sr-only"
                        checked={formData.permissions.system.apiIntegrations}
                        onChange={() =>
                          handleTogglePermission("system", "apiIntegrations")
                        }
                      />
                      <div
                        className={`w-full h-full rounded-full border-2 transition-colors duration-300 ${
                          formData.permissions.system.apiIntegrations
                            ? "bg-[#3E3212] border-[#FFCA20]"
                            : "bg-[#3E3212] border-[#FFCA20]"
                        }`}
                      ></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.system.apiIntegrations
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Lead Management Section */}
              <div>
                {/* Parent Lead Management Checkbox */}
                <div className="mb-2">
                  <input
                    type="checkbox"
                    id="lead_management"
                    className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:border-yellow-400 checked:appearance-none relative cursor-pointer
        before:content-['✔'] before:absolute before:text-[#ffca20] before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100 mr-2"
                    checked={Object.values(formData.permissions.lead).some(
                      (val) => val
                    )}
                    onChange={() => {}}
                  />
                  <label htmlFor="lead_management" className="font-semibold">
                    Lead Management
                  </label>
                </div>

                {/* Permission Toggles */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Reject & Approve Leads */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="rejectApproveLeads">
                      Reject & Approve Leads
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="rejectApproveLeads"
                        className="sr-only"
                        checked={formData.permissions.lead.rejectApproveLeads}
                        onChange={() =>
                          handleTogglePermission("lead", "rejectApproveLeads")
                        }
                      />
                      <div
                        className={`w-full h-full rounded-full border-2 transition-colors duration-300 bg-[#3E3212] border-[#FFCA20]`}
                      ></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.lead.rejectApproveLeads
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Request Documents */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="requestDocuments">
                      Request Documents From Customer
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="requestDocuments"
                        className="sr-only"
                        checked={formData.permissions.lead.requestDocuments}
                        onChange={() =>
                          handleTogglePermission("lead", "requestDocuments")
                        }
                      />
                      <div
                        className={`w-full h-full rounded-full border-2 transition-colors duration-300 bg-[#3E3212] border-[#FFCA20]`}
                      ></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.lead.requestDocuments
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* View & Verify Documents */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="viewVerifyDocuments">
                      View & Verify Documents
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="viewVerifyDocuments"
                        className="sr-only"
                        checked={formData.permissions.lead.viewVerifyDocuments}
                        onChange={() =>
                          handleTogglePermission("lead", "viewVerifyDocuments")
                        }
                      />
                      <div
                        className={`w-full h-full rounded-full border-2 transition-colors duration-300 bg-[#3E3212] border-[#FFCA20]`}
                      ></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.lead.viewVerifyDocuments
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* View Loan History */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="viewLoanHistory">
                      View All Loan History
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="viewLoanHistory"
                        className="sr-only"
                        checked={formData.permissions.lead.viewLoanHistory}
                        onChange={() =>
                          handleTogglePermission("lead", "viewLoanHistory")
                        }
                      />
                      <div
                        className={`w-full h-full rounded-full border-2 transition-colors duration-300 bg-[#3E3212] border-[#FFCA20]`}
                      ></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.lead.viewLoanHistory
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Loan Management Section */}
              <div>
                {/* Parent Loan Management Checkbox */}
                <div className="mb-2">
                  <input
                    type="checkbox"
                    id="loan_management"
                    className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:border-yellow-400 checked:appearance-none relative cursor-pointer
        before:content-['✔'] before:absolute before:text-[#ffca20] before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100 mr-2"
                    checked={Object.values(formData.permissions.loan).some(
                      (val) => val
                    )}
                    onChange={() => {}}
                  />
                  <label htmlFor="loan_management" className="font-semibold">
                    Loan Management
                  </label>
                </div>

                {/* Permission Toggles */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Create & Assign Loan Applications */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="createAssignApplications">
                      Create & Assign Loan Applications
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="createAssignApplications"
                        className="sr-only"
                        checked={
                          formData.permissions.loan.createAssignApplications
                        }
                        onChange={() =>
                          handleTogglePermission(
                            "loan",
                            "createAssignApplications"
                          )
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.loan.createAssignApplications
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Approve & Reject Loans */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="approveRejectLoans">
                      Approve & Reject Loans
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="approveRejectLoans"
                        className="sr-only"
                        checked={formData.permissions.loan.approveRejectLoans}
                        onChange={() =>
                          handleTogglePermission("loan", "approveRejectLoans")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.loan.approveRejectLoans
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Modify Loan Conditions */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="modifyConditions">
                      Modify Loan Conditions
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="modifyConditions"
                        className="sr-only"
                        checked={formData.permissions.loan.modifyConditions}
                        onChange={() =>
                          handleTogglePermission("loan", "modifyConditions")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.loan.modifyConditions
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* View All Loan History */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="viewAllHistory">
                      View All Loan History
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="viewAllHistory"
                        className="sr-only"
                        checked={formData.permissions.loan.viewAllHistory}
                        onChange={() =>
                          handleTogglePermission("loan", "viewAllHistory")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.loan.viewAllHistory
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Staff Management Section */}
              <div>
                {/* Parent Checkbox */}
                <div className="mb-2">
                  <input
                    type="checkbox"
                    id="staff_management"
                    className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:border-yellow-400 checked:appearance-none relative cursor-pointer
        before:content-['✔'] before:absolute before:text-[#ffca20] before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100 mr-2"
                    checked={Object.values(formData.permissions.staff).some(
                      (val) => val
                    )}
                    onChange={() => {}}
                  />
                  <label htmlFor="staff_management" className="font-semibold">
                    Staff Management
                  </label>
                </div>

                {/* Toggle Permissions */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* View All Staff */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="viewAll">View All Staff</label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="viewAll"
                        className="sr-only"
                        checked={formData.permissions.staff.viewAll}
                        onChange={() =>
                          handleTogglePermission("staff", "viewAll")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.staff.viewAll
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Add & Remove Staff Members */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="addRemove">
                      Add & Remove Staff Members
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="addRemove"
                        className="sr-only"
                        checked={formData.permissions.staff.addRemove}
                        onChange={() =>
                          handleTogglePermission("staff", "addRemove")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.staff.addRemove
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Assign & Edit Roles */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="assignEditRoles">Assign & Edit Roles</label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="assignEditRoles"
                        className="sr-only"
                        checked={formData.permissions.staff.assignEditRoles}
                        onChange={() =>
                          handleTogglePermission("staff", "assignEditRoles")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.staff.assignEditRoles
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Deactivate/Activate Staff */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="deactivateActivate">
                      Deactivate/Activate Existing Staff
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="deactivateActivate"
                        className="sr-only"
                        checked={formData.permissions.staff.deactivateActivate}
                        onChange={() =>
                          handleTogglePermission("staff", "deactivateActivate")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.staff.deactivateActivate
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Financial Operations Section */}
              <div>
                {/* Parent Checkbox */}
                <div className="mb-2">
                  <input
                    type="checkbox"
                    id="financial_operations"
                    className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:border-yellow-400 checked:appearance-none relative cursor-pointer
        before:content-['✔'] before:absolute before:text-[#ffca20] before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100 mr-2"
                    checked={Object.values(formData.permissions.finance).some(
                      (val) => val
                    )}
                    onChange={() => {}}
                  />
                  <label
                    htmlFor="financial_operations"
                    className="font-semibold"
                  >
                    Financial Operations
                  </label>
                </div>

                {/* Toggle Permissions */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Process Loan Disbursements */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="processLoanDisbursements">
                      Process Loan Disbursements
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="processLoanDisbursements"
                        className="sr-only"
                        checked={
                          formData.permissions.finance.processLoanDisbursements
                        }
                        onChange={() =>
                          handleTogglePermission(
                            "finance",
                            "processLoanDisbursements"
                          )
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.finance.processLoanDisbursements
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Manage Partner Bank Transactions */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="managePartnerTransactions">
                      Manage Partner Bank Transactions
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="managePartnerTransactions"
                        className="sr-only"
                        checked={
                          formData.permissions.finance.managePartnerTransactions
                        }
                        onChange={() =>
                          handleTogglePermission(
                            "finance",
                            "managePartnerTransactions"
                          )
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.finance.managePartnerTransactions
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Generate Financial Reports */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="generateReports">
                      Generate Financial Reports
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="generateReports"
                        className="sr-only"
                        checked={formData.permissions.finance.generateReports}
                        onChange={() =>
                          handleTogglePermission("finance", "generateReports")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.finance.generateReports
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* View Total Loan Amount */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="viewTotal">View Total Loan Amount</label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="viewTotal"
                        className="sr-only"
                        checked={formData.permissions.finance.viewTotal}
                        onChange={() =>
                          handleTogglePermission("finance", "viewTotal")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.finance.viewTotal
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Affiliate Management Section */}
              <div>
                {/* Parent Checkbox */}
                <div className="mb-2">
                  <input
                    type="checkbox"
                    id="affiliate_management"
                    className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:border-yellow-400 checked:appearance-none relative cursor-pointer
        before:content-['✔'] before:absolute before:text-[#ffca20] before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100 mr-2"
                    checked={Object.values(formData.permissions.affiliate).some(
                      (val) => val
                    )}
                    onChange={() => {}}
                  />
                  <label
                    htmlFor="affiliate_management"
                    className="font-semibold"
                  >
                    Affiliate & Banking Partner Management
                  </label>
                </div>

                {/* Toggle Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Toggle 1 */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="addManagePartners">
                      Add & Manage Banking Partners
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="addManagePartners"
                        className="sr-only"
                        checked={
                          formData.permissions.affiliate.addManagePartners
                        }
                        onChange={() =>
                          handleTogglePermission(
                            "affiliate",
                            "addManagePartners"
                          )
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.affiliate.addManagePartners
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Toggle 2 */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="assignLoanFiles">
                      Assign Loan Files to Banking Partners
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="assignLoanFiles"
                        className="sr-only"
                        checked={formData.permissions.affiliate.assignLoanFiles}
                        onChange={() =>
                          handleTogglePermission("affiliate", "assignLoanFiles")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.affiliate.assignLoanFiles
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Toggle 3 */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="viewAllPartners">
                      View All Partners & Affiliates
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="viewAllPartners"
                        className="sr-only"
                        checked={formData.permissions.affiliate.viewAllPartners}
                        onChange={() =>
                          handleTogglePermission("affiliate", "viewAllPartners")
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.affiliate.viewAllPartners
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>

                  {/* Toggle 4 */}
                  <div className="flex items-center justify-between p-3 border border-[#333333] rounded">
                    <label htmlFor="manageCommission">
                      Manage Affiliate Commission
                    </label>
                    <div className="relative w-12 h-6">
                      <input
                        type="checkbox"
                        id="manageCommission"
                        className="sr-only"
                        checked={
                          formData.permissions.affiliate.manageCommission
                        }
                        onChange={() =>
                          handleTogglePermission(
                            "affiliate",
                            "manageCommission"
                          )
                        }
                      />
                      <div className="w-full h-full rounded-full border-2 bg-[#3E3212] border-[#FFCA20] transition-colors duration-300"></div>
                      <div
                        className={`absolute top-0 left-0 w-6 h-6 rounded-full bg-[#FFCA20] transform transition-transform duration-300 ${
                          formData.permissions.affiliate.manageCommission
                            ? "translate-x-6"
                            : "translate-x-0"
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-between space-x-0 sm:space-x-4 space-y-3 sm:space-y-0">
              <button
                type="button"
                onClick={handleCancel}
                className="px-6 py-2 border-2 border-white text-white rounded w-full sm:w-auto hover:bg-red-500 transition-colors duration-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 bg-[#FFCA20] text-black font-semibold rounded w-full sm:w-auto flex items-center justify-center"
                disabled={isSubmitting} // Disable button when submitting
              >
                {isSubmitting ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-black"></div>
                ) : (
                  "Create Staff"
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddStaffForm;
